import React from 'react';
import { localeToLngName } from '../../constants';
import PropTypes from 'prop-types';

const LangaugeDropDown = ({ flagSource, countryCode, selectedLngName, handleChange }) => {
  return (
    <div id='country-select'>
      <span id='flag'>
        <img className='flag' src={flagSource} alt={countryCode} />
      </span>
      <select id='locale' name='locale' className='flag-select' value={selectedLngName} onChange={handleChange}>
        {Object.keys(localeToLngName)
          .sort()
          .map((lngCode) => (
            <option key={localeToLngName[lngCode]} value={localeToLngName[lngCode]}>
              {localeToLngName[lngCode]}
            </option>
          ))}
      </select>
    </div>
  );
};

LangaugeDropDown.propTypes = {
  flagSource: PropTypes.string,
  countryCode: PropTypes.string,
  selectedLngName: PropTypes.string,
  handleChange: PropTypes.func,
};

export default LangaugeDropDown;
